<div class="payment-confirm-container">
  <!-- Loading overlay -->
  <div class="loading-overlay" *ngIf="qrPaymentService.isLoadingLock()">
    <div class="loading-content">
      <div class="circle-loader"></div>
      <p>Procesando</p>
    </div>
  </div>
  <button class="back-button" (click)="backButton()">
    <img class="arrow" src="assets/icons/arrow-back.svg" alt="Arrow" />
  </button>
  <app-onboarding-header
    [title]="'Pagar a'"
    [subtitle]="getRecipientDisplay()"
  ></app-onboarding-header>
  <div class="payment-amount-section">
    <form [formGroup]="paymentForm" class="payment-form">
      <div class="amount-hero">
        <div class="amount-input-container">
          <app-phone-number-amount-input
            [value]="amountValue"
            [disabled]="qrPaymentService.shouldDisableAmountInput()"
            [placeholder]="'0'"
            [currencySymbol]="''"
            [autoFocus]="!qrPaymentService.shouldDisableAmountInput()"
            (valueChange)="onAmountValueChange($event)"
            (digitsChange)="onAmountDigitsChange($event)"
          ></app-phone-number-amount-input>
          <div class="amount-currency">
            ARS <img src="assets/images/flags/arg-circle.svg" alt="Arg" />
          </div>
        </div>

        <div class="wld-conversion" *ngIf="getWldAmount()">
          <span class="approx-sign">≈</span> {{ getWldAmount() }} WLD
        </div>

        <div class="balance-info">Tu balance: {{ getWldBalance() }} WLD</div>
      </div>

      <div
        class="error-message"
        *ngIf="paymentForm.get('amount')?.invalid && paymentForm.get('amount')?.touched"
      >
        <app-input-hint type="error" message="Ingresa un monto válido"></app-input-hint>
      </div>
    </form>
  </div>
</div>
<app-onboarding-footer
  [label]="'Pagar'"
  [disabled]="isConfirmDisabled()"
  (confirm)="confirmPayment()"
></app-onboarding-footer>
